var $f43313d21d3fd8e2$exports = {};
console.log("Hello World");


//# sourceMappingURL=index.12d7c9e2.js.map
